import { StepButton } from '@mui/material'
import Box from '@mui/material/Box'
import Step from '@mui/material/Step'
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector'
import StepLabel from '@mui/material/StepLabel'
import MuiStepper from '@mui/material/Stepper'
import { styled } from '@mui/material/styles'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { useBreakpoints } from '@/hooks/useBreakpoints'

const ColorLineConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.warning.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.warning.main,
    },
  },
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    left: 'calc(-50% + 1%)',
    right: 'calc(50% + 1%)',
  },
}))

const StyledBox = styled(Box)(() => {
  const { isDisplay1300 } = useBreakpoints()
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: isDisplay1300 ? '16px' : '2px',
    paddingTop: '8px',
    paddingBottom: '16px',
  }
})

const StyledMuiStepper = styled(MuiStepper)(({ theme }) => {
  const { isDisplay1300 } = useBreakpoints()
  return {
    width: isDisplay1300 ? '80%' : '100%',
    '& .MuiStep-root': {
      paddingLeft: isDisplay1300 ? '8px' : '0px !important',
      paddingRight: isDisplay1300 ? '8px' : '0px !important',
    },
    '& .MuiStepConnector-root': {
      left: 'calc(-50% + 7px)',
      right: 'calc(50% - 8px)',
    },
    '& .MuiStepConnector-line': {
      borderColor: theme.palette.background.stepper,
      zIndex: 1,
    },
  }
})

const StyledStepLabel = styled(StepLabel)(({ theme }) => {
  const { isDisplay1300 } = useBreakpoints()
  return {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiSvgIcon-root': {
        color: theme.palette.background.stepper,
        height: '18px',
        width: '18px',
        marginTop: '0.25rem !important',
      },
      '& .MuiStepIcon-check': {
        width: '12px',
        height: '9px',
        transform: 'translate(-50%, -50%) scale(0.8)',
      },
      '& .MuiStepIcon-text': {
        fill: theme.palette.text.stepper,
      },
      '&.Mui-active, &.Mui-completed': {
        '& .MuiSvgIcon-root, & .MuiStepIcon-text': {
          color: theme.palette.warning.main,
          fill: theme.palette.warning.main,
          zIndex: 2,
        },
      },
    },
    '& .MuiStepLabel-label': {
      color: theme.palette.text.stepper,
      whiteSpace: isDisplay1300 ? 'nowrap' : 'normal',
      marginTop: '0.25rem !important',
      '&.Mui-active, &.Mui-completed': {
        color: theme.palette.common.white,
      },
    },
  }
})

interface ColorMatchingStepperProps {
  activeStep?: number
  steps: { label: string; id: string }[]
  onStepClick?: (stepIndex: number) => void
}

const ColorMatchingStepper: React.FC<ColorMatchingStepperProps> = ({
  activeStep,
  steps = [],
  onStepClick,
}) => {
  const { t } = useTranslation()
  return (
    <StyledBox>
      <StyledMuiStepper
        activeStep={activeStep}
        alternativeLabel
        connector={<ColorLineConnector />}
      >
        {steps.map((step, index) => (
          <Step key={step.id}>
            <StepButton onClick={() => onStepClick?.(index)}>
              <StyledStepLabel>{t(step.label)}</StyledStepLabel>
            </StepButton>
          </Step>
        ))}
      </StyledMuiStepper>
    </StyledBox>
  )
}

export default ColorMatchingStepper
